import React, {useState, useEffect} from 'react'
import {useSelector} from 'react-redux';
import {CCard, CCardBody, CCol, CRow, CProgress, CLabel, CTextarea, CButton, CImg} from 'compat/coreui'
import axios from 'axios';
import Rating from 'react-rating';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';


export default function Followers(props) {
    const [follow, setFollow] = useState('');
    const [rating, setRating] = useState(0);
    const [value, setValue] = useState(0);
    const [voteCount, setVoteCount] = useState(0);
    const [show, setShow] = useState(false);
    const token = localStorage.getItem('token');
    const user = useSelector(state => state.user);
    
    const followHandler = () => {

        axios({url: `${process.env.REACT_APP_APP_API_URL}/api/follow`,
               headers: {
                    Authorization: `Bearer ${token}`
               },
               method: `GET`
            }).then(response => {
                console.log('follow api response', response);
                if(response.data.status){
                    setFollow(response.data.following);
                } 
            }).catch(console.log)
    }

    useEffect(()=>{
      followHandler()
    }, [])

    return (
         <div>
            <CCard className="business-dashboard">
                <CCardBody>
                    <CRow>
                        <CCol  lg={12}className="review-headding"><h2>Followers</h2></CCol>
                        <CCol xl={12}>
                            <table className="review-table">
                                <tbody>
                                    {follow && follow.map((followItem, i) => {
                                        return(<tr key={i}>
                                                    <td><CImg  width="77%" src="/images/smoke1.png" className="rounded-circle" /></td>
                                                    <td>
                                                        <div>
                                                            <p>{followItem.following.email}</p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}) }
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </div>
    )
}